import { useState } from 'react';
import { mixPostV1, mixVNDtoUSA } from 'services/mixin';
import { message } from 'antd';
import StripeForm from './StripeCheckout';
import '../../pages/Dashboard/Payment/Checkout.scss'

interface CheckoutPaymentFormProps {
  user: any;
  detail: any;
}

const CheckoutPaymentForm: React.FC<CheckoutPaymentFormProps> = ({ user, detail }) => {
  const [paymentMethod, setPaymentMethod] = useState(1)
  // const [isShowPaymentDetail, setIsShowPaymentDetail] = useState(false)

  const togglePaymentMethod = (id:any) => {
    setPaymentMethod(id)
  }

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault()

  //   switch(paymentMethod) {
  //     case 3 :
  //       if(user) {
  //         try {
  //           const res = await mixPostV1('/api/v1/fe/order/create_v2_test', {
  //             customer_id: user.info.id,
  //             total: mixVNDtoUSA(detail.price),
  //             package_id: detail.id,
  //             payment: 3,
  //             is_subscription: 0,
  //           })

  //           if(res.status) {
  //             message.success('Đơn hàng đã được tạo')
  //           } else {
  //             message.error(res.error)
  //           }
  //         } catch (err) {
  //           message.error(err?.message || 'Có lỗi')
  //           console.log(err)
  //         }
  //       }
  //       break;
  //     default:
  //       message.warning('Vui lòng chọn hình thức thanh toán')
  //   }
  // }
  return (
    <div className="App-Payment">
      <main>
        <div className="CheckoutPaymentForm">
          {/* <div style={{ height: 120 }}>
                            <div>
                            <div className="PaymentRequestOrHeader">
                                <div
                                className="PaymentHeaderContainer"
                                style={{
                                    display: "none",
                                    opacity: 0,
                                    height: 0,
                                    overflow: "hidden"
                                }}
                                >
                                <h2 className="PaymentHeader Text Text-color--gray800 Text-fontSize--16 Text-fontWeight--500">
                                    Thông tin liên hệ
                                </h2>
                                </div>
                                <div
                                    className="ButtonAndDividerContainer"
                                    style={{
                                        overflow: "hidden",
                                        opacity: 1,
                                        height: "auto",
                                        display: "block"
                                    }}
                                >
                                <div className="ButtonContainer">
                                    <div className="ButtonWrapper">
                                    <div className="ButtonWrapper">
                                        <div
                                        className="ElementsExpressCheckoutElement StripeElement"
                                        data-testid="express-checkout-element"
                                        >
                                        <div
                                            className="__PrivateStripeElement"
                                            style={{
                                            margin: "-4px 0px !important",
                                            padding: "0px !important",
                                            border: "none !important",
                                            display: "block !important",
                                            background: "transparent !important",
                                            position: "relative !important",
                                            opacity: "1 !important",
                                            transition: "height 0.35s !important"
                                            }}
                                        >
                                            <iframe
                                            name="__privateStripeFrame4254"
                                            frameBorder={0}
                                            allowTransparency="true"
                                            scrolling="no"
                                            role="presentation"
                                            allow="payment *"
                                            src="https://js.stripe.com/v3/elements-inner-express-checkout-06e6e07833a8392b13b2347517676641.html#__shared_params__[version]=v3&__shared_params__[light_experiment_assignments]=%7B%22token%22%3A%223f8a9ad0-e0f1-42ba-a705-7cc8006887ac%22%2C%22assignments%22%3A%7B%22link_skip_autofill_modal_mount%22%3A%22control%22%2C%22link_skip_wallets_link_never%22%3A%22control%22%7D%7D&wait=false&rtl=false&publicOptions[buttonHeight]=55&publicOptions[layout][maxColumns]=4&publicOptions[layout][maxRows]=1&publicOptions[layout][overflow]=auto&publicOptions[wallets][applePay]=always&publicOptions[wallets][googlePay]=never&publicOptions[wallets][paypal]=auto&publicOptions[wallets][link]=auto&publicOptions[wallets][klarna]=auto&publicOptions[wallets][amazonPay]=auto&publicOptions[__checkout][__linkPurchaseProtectionsData][isEligible]=false&publicOptions[__checkout][__linkPurchaseProtectionsData][type]=shopping&publicOptions[__checkout][__linkProtectionsEligibleAndRolledOut]=false&publicOptions[__checkout][__linkUnrecognizedProtectionsHoldback]=false&publicOptions[__checkout][minApplePayVersion]=2&publicOptions[__checkout][minGooglePayVersion][major]=2&publicOptions[__checkout][minGooglePayVersion][minor]=0&publicOptions[__checkout][applePayIdentifierAccount]=acct_1EPydaAHwgQ34jlN&publicOptions[paymentMethods][applePay]=always&publicOptions[paymentMethods][googlePay]=never&publicOptions[paymentMethods][paypal]=auto&publicOptions[paymentMethods][link]=auto&publicOptions[paymentMethods][klarna]=auto&publicOptions[paymentMethods][amazonPay]=auto&elementsInitSource=checkout&elementId=expressCheckout-ec853797-1bb3-4dc3-a4df-2cbb582e9730&componentName=expressCheckout&keyMode=live&apiKey=pk_live_qzXXvTG0TUOVkTZLWsEq7Oqm002yaRpLGH&frameMessagingStrategy=direct&referrer=https%3A%2F%2Fcheckout.stripe.com%2Fc%2Fpay%2Fcs_live_b1bKzkfKNOlemX16UXqoT88VwSasDZvHXu0qiM9Y2lirhKthjQ4ODmLhNX%23fidnandhYHdWcXxpYCc%252FJ2FgY2RwaXEnKSd2cGd2ZndsdXFsamtQa2x0cGBrYHZ2QGtkZ2lgYSc%252FY2RpdmApJ2R1bE5gfCc%252FJ3VuWmlsc2BadH9dXXNRQjVRUEpTblFfSVJ2QHQySnRoNTU3fGRXdUlCTScpJ2N3amhWYHdzYHcnP3F3cGApJ2dkZm5id2pwa2FGamlqdyc%252FJyZjY2NjY2MnKSdpZHxqcHFRfHVgJz8naHBpcWxabHFgaCcpJ2BrZGdpYFVpZGZgbWppYWB3dic%252FcXdwYHgl&controllerId=__privateStripeController4251"
                                            title="Khung Express Checkout an toàn"
                                            style={{
                                                border: "0px !important",
                                                margin: "-4px",
                                                padding: "0px !important",
                                                width: "calc(100% + 8px)",
                                                minWidth: "100% !important",
                                                overflow: "hidden !important",
                                                display: "block !important",
                                                userSelect: "none !important",
                                                transform: "translate(0px) !important",
                                                colorScheme: "light only !important",
                                                height: 63,
                                                transition: "height 0.35s, opacity 0.4s 0.1s"
                                            }}
                                            />
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="Divider">
                                    <hr />
                                    <p className="Divider-Text Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400">
                                    <span className="DividerText">Hoặc</span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div> */}
          <form
            className="PaymentForm-form PaymentForm-form--stickyHeader"
            noValidate=""
            id="payment-form"
            // onSubmit={handleSubmit}
          >
            <div style={{ height: "741.391px" }}>
              <div>
                <div style={{ opacity: 1 }}>
                  <div className="App-Global-Fields flex-container spacing-16 direction-column wrap-wrap">
                    <div className="flex-item width-12">
                      <div className="FormFieldGroup-container">
                        <div className="ReadOnlyForm-container">
                          <div className="ReadOnlyForm F-L8wL7C__EmailFormFieldGroup--readOnlyForm ReadOnlyForm--withShadow">
                            <div className="ReadOnlyFormField-email ReadOnlyFormField">
                              <div className="ReadOnlyFormField-container">
                                <div className="ReadOnlyFormField-contentContainer">
                                  <div className="ReadOnlyFormField-label">
                                    <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                      Email
                                    </span>
                                  </div>
                                  <div className="ReadOnlyFormField-content">
                                    <div className="ReadOnlyFormField-titleContainer">
                                      <div className="ReadOnlyFormField-title">
                                        {user?.info.email}
                                      </div>
                                      <div className="ReadOnlyFormField-action" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex-item width-12">
                      <h2 className="PaymentMethod-Heading Text Text-color--gray800 Text-fontSize--16 Text-fontWeight--500">
                        Payment method
                      </h2>
                    </div>
                  </div>
                  <div
                    className="PaymentMethodForm"
                    style={{ opacity: 1, height: "auto" }}
                  >
                    <div
                      className="Accordion PaymentMethodFormAccordion"
                      role="list"
                      data-name="paymentMethodFormAccordion"
                    >
                      <div className="AnimatePresence PaymentMethodFormVisible-container">
                        <div className="AnimatePresence-inner">
                          <div className="AnimateSinglePresence PaymentMethodFormAccordionItem-container">
                            <div className="AnimateSinglePresenceItem">
                              <div
                                className="AccordionItem PaymentMethodFormAccordionItem PaymentMethodFormAccordionItem--selected PaymentMethodFormAccordionItem--overflowVisible PaymentMethodFormAccordionItem--compact"
                                role="listitem"
                                data-testid="card-accordion-item"
                              >
                                <div className="AccordionItem-wrapper">
                                  <div className="AnimatePresence">
                                    <div className="AnimatePresence-inner">
                                      <div className="AccordionItemCover PaymentMethodFormAccordionItem PaymentMethodFormAccordionItem--selected PaymentMethodFormAccordionItem--overflowVisible-cover">
                                        <div className="AccordionItemHeader AccordionItemCover-header AccordionItemHeader--clickable">
                                          <div className="AccordionItemHeader-content">
                                            <div className="flex-container">
                                              <div className="AccordionItemCover-label">
                                                <div
                                                  className="flex-container direction-row align-items-center wrap-wrap"
                                                  style={{
                                                    height: "auto",
                                                    width: "100%"
                                                  }}
                                                >
                                                  <span className="Text Text-color--gray400 Text-fontSize--13 Text-fontWeight--500" />
                                                </div>
                                              </div>
                                              <div className="flex-item width-grow">
                                                <div className="flex-container direction-row justify-content-space-between align-items-flex-start">
                                                  <div className="AccordionItemCover-titleContainer flex-container direction-row justify-content-space-between">
                                                    <div className="AccordionItemCover-title Text Text-color--gray800 Text-fontSize--14">
                                                      <div className="PaymentMethodFormAccordionItemTitle PaymentMethodFormAccordionItemTitle-selected flex-container direction-row justify-content-space-between align-items-center">
                                                        <div className="flex-container direction-row align-items-center">
                                                          <input
                                                            id="payment-method-accordion-item-title-card"
                                                            aria-checked="true"
                                                            aria-labelledby="payment-method-label-card"
                                                            name="payment-method-accordion-item-title"
                                                            type="radio"
                                                            className="RadioButton PaymentMethodFormAccordionItemTitle-radio"
                                                            tabIndex={-1}
                                                            checked={paymentMethod === 1}
                                                          />
                                                          <div className="PaymentMethodFormAccordionItemTitle-icon">
                                                            <img
                                                              src="https://js.stripe.com/v3/fingerprinted/img/card-ce24697297bd3c6a00fdd2fb6f760f0d.svg"
                                                              alt=""
                                                              className="Icon Icon--md"
                                                            />
                                                          </div>
                                                          <div id="payment-method-label-card">
                                                            Card
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="AccordionItemCover-actionContainer AccordionItemCover-actionContainer--noButton">
                                                    <button
                                                      className="Button AccordionButton AccordionButton-open AccordionButton-expandedClickArea AccordionButton-expandedFocusArea Button--link Button--sm"
                                                      type="button"
                                                      aria-label="Thanh toán bằng thẻ"
                                                      data-testid="card-accordion-item-button"
                                                      onClick={() => togglePaymentMethod(1)}
                                                    >
                                                      <div className="flex-container justify-content-center align-items-center" />
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div 
                                    className="AnimatePresence" 
                                    style={{
                                      ...(paymentMethod === 1 ? { display: 'block' } : { display: 'none' }),
                                      // ...(isShowPaymentDetail ? { opacity: 1 } : { opacity: 0.4, pointerEvents: 'none'})
                                    }}
                                  >
                                    <StripeForm user={user} detail={detail}/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="AnimatePresence PaymentMethodFormVisible-container">
                                        <div className="AnimatePresence-inner">
                                        <div className="AnimateSinglePresence PaymentMethodFormAccordionItem-container">
                                            <div className="AnimateSinglePresenceItem">
                                            <div
                                                className="AccordionItem PaymentMethodFormAccordionItem PaymentMethodFormAccordionItem--compact"
                                                role="listitem"
                                                data-testid="link_instant_debit-accordion-item"
                                            >
                                                <div className="AccordionItem-wrapper">
                                                <div className="AnimatePresence">
                                                    <div className="AnimatePresence-inner">
                                                    <div className="AccordionItemCover PaymentMethodFormAccordionItem-cover">
                                                        <div className="AccordionItemHeader AccordionItemCover-header AccordionItemHeader--clickable">
                                                        <div className="AccordionItemHeader-content">
                                                            <div className="flex-container">
                                                            <div className="AccordionItemCover-label">
                                                                <div
                                                                className="flex-container direction-row align-items-center wrap-wrap"
                                                                style={{
                                                                    height: "auto",
                                                                    width: "100%"
                                                                }}
                                                                >
                                                                <span className="Text Text-color--gray400 Text-fontSize--13 Text-fontWeight--500" />
                                                                </div>
                                                            </div>
                                                            <div className="flex-item width-grow">
                                                                <div className="flex-container direction-row justify-content-space-between align-items-flex-start">
                                                                <div className="AccordionItemCover-titleContainer flex-container direction-row justify-content-space-between">
                                                                    <div className="AccordionItemCover-title Text Text-color--gray800 Text-fontSize--14">
                                                                    <div className="PaymentMethodFormAccordionItemTitle flex-container direction-row justify-content-space-between align-items-center">
                                                                        <div className="flex-container direction-row align-items-center">
                                                                        <input
                                                                            id="payment-method-accordion-item-title-link_instant_debit"
                                                                            aria-checked="false"
                                                                            aria-labelledby="payment-method-label-link_instant_debit"
                                                                            name="payment-method-accordion-item-title"
                                                                            type="radio"
                                                                            className="RadioButton PaymentMethodFormAccordionItemTitle-radio"
                                                                            tabIndex={-1}
                                                                            defaultValue="link_instant_debit"
                                                                        />
                                                                        <div className="PaymentMethodFormAccordionItemTitle-icon">
                                                                            <img
                                                                            src="https://js.stripe.com/v3/fingerprinted/img/bank-de5c9ead31505d57120e98291cb20e57.svg"
                                                                            alt=""
                                                                            className="Icon Icon--md"
                                                                            />
                                                                        </div>
                                                                        <div id="payment-method-label-link_instant_debit">
                                                                            Ngân hàng
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                <div className="AccordionItemCover-actionContainer AccordionItemCover-actionContainer--noButton">
                                                                    <button
                                                                    className="Button AccordionButton AccordionButton-open AccordionButton-expandedClickArea AccordionButton-expandedFocusArea Button--link Button--sm"
                                                                    type="button"
                                                                    aria-label="Thanh toán bằng ngân hàng"
                                                                    data-testid="link_instant_debit-accordion-item-button"
                                                                    >
                                                                    <div className="flex-container justify-content-center align-items-center" />
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div> */}
                      <div className="AnimateSinglePresence PaymentMethodFormOverflow-container PaymentMethodFormOverflow-container--compact">
                        <div className="AnimateSinglePresenceItem">
                          <div />
                        </div>
                      </div>
                    </div>
                    {/* <div className="AnimateSinglePresence" />
                                    <div className="AnimateSinglePresence">
                                    <div className="AnimateSinglePresenceItem">
                                        <div className="LinkSignUpForm">
                                        <div className="SignUpForm-signUpFormContainer flex-item width-12">
                                            <div className="AnimateSinglePresence">
                                            <div className="AnimateSinglePresenceItem">
                                                <div>
                                                <div>
                                                    <div className="SignUpForm SignUpForm--withTerms">
                                                        <div className="SignUpForm-headerContainer">
                                                            <div className="FormFieldCheckbox SignUpForm-checkbox">
                                                            <div className="CheckboxField">
                                                                <div className="Checkbox">
                                                                <div className="Checkbox-InputContainer">
                                                                    <input
                                                                    id="enableStripePass"
                                                                    name="enableStripePass"
                                                                    type="checkbox"
                                                                    className="Checkbox-Input"
                                                                    />
                                                                    <span className="Checkbox-StyledInput">
                                                                    <svg
                                                                        className="InlineSVG Icon Checkbox-tickSvg"
                                                                        focusable="false"
                                                                        width={21}
                                                                        height={19}
                                                                        viewBox="0 0 21 19"
                                                                        fill="none"
                                                                    >
                                                                        <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd"
                                                                        d="M19.2242 3.76495L8.52368 17.1606L2.25391 10.6793L4.41013 8.59346L8.30846 12.6233L16.8802 1.89258L19.2242 3.76495Z"
                                                                        fill="currentColor"
                                                                        />
                                                                    </svg>
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <label htmlFor="enableStripePass">
                                                                    <span className="Checkbox-Label Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                                                        <div
                                                                        className="SignUpForm-labelHeader"
                                                                        style={{ opacity: 1 }}
                                                                        >
                                                                        Lưu thông tin của tôi để
                                                                        thanh toán nhanh chóng hơn
                                                                        </div>
                                                                    </span>
                                                                    </label>
                                                                    <div className="Checkbox-Description Text Text-color--gray500 Text-fontWeight--400">
                                                                    <div
                                                                        className="SignUpForm-subLabel"
                                                                        id="link-registration-subheader-message"
                                                                    >
                                                                        Thanh toán an toàn tại
                                                                        StackBlitz, Inc. và ở mọi
                                                                        nơi hỗ trợ{" "}
                                                                        <a
                                                                        className="Link Link--checkout--secondary"
                                                                        target="_self"
                                                                        >
                                                                        Link
                                                                        </a>
                                                                        .
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    <div
                                                        className="AnimateSinglePresence"
                                                        style={{ height: 0 }}
                                                    />
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div> */}
                  </div>
                  <div className="PaymentForm-confirmPaymentContainer mt5 flex-item width-grow">
                    <div className="ConfirmPayment">
                      <div className="flex-item width-12" />
                      <div className="flex-item width-12">
                        <div>
                          <div
                            data-testid="submit-wallet-button"
                            style={{ display: "none" }}
                          >
                            <div
                              className="ElementsExpressCheckoutElement StripeElement"
                              data-testid="express-checkout-element"
                            >
                              <div
                                className="__PrivateStripeElement"
                                style={{
                                  margin: "-4px 0px !important",
                                  padding: "0px !important",
                                  border: "none !important",
                                  display: "block !important",
                                  background: "transparent !important",
                                  position: "relative !important",
                                  opacity: "1 !important",
                                  transition: "height 0.35s !important"
                                }}
                              >
                                <iframe
                                  name="__privateStripeFrame4256"
                                  frameBorder={0}
                                  allowTransparency="true"
                                  scrolling="no"
                                  role="presentation"
                                  allow="payment *"
                                  src="https://js.stripe.com/v3/elements-inner-express-checkout-06e6e07833a8392b13b2347517676641.html#__shared_params__[version]=v3&__shared_params__[light_experiment_assignments]=%7B%22token%22%3A%223f8a9ad0-e0f1-42ba-a705-7cc8006887ac%22%2C%22assignments%22%3A%7B%22link_skip_autofill_modal_mount%22%3A%22control%22%2C%22link_skip_wallets_link_never%22%3A%22control%22%7D%7D&wait=false&rtl=false&publicOptions[buttonHeight]=55&publicOptions[layout][maxColumns]=4&publicOptions[layout][maxRows]=1&publicOptions[layout][overflow]=auto&publicOptions[wallets][applePay]=never&publicOptions[wallets][googlePay]=auto&publicOptions[wallets][paypal]=never&publicOptions[wallets][link]=never&publicOptions[wallets][klarna]=never&publicOptions[wallets][amazonPay]=never&publicOptions[__checkout][minApplePayVersion]=2&publicOptions[__checkout][minGooglePayVersion][major]=2&publicOptions[__checkout][minGooglePayVersion][minor]=0&publicOptions[__checkout][applePayIdentifierAccount]=acct_1EPydaAHwgQ34jlN&publicOptions[__checkout][hideGooglePayOverlay]=true&publicOptions[paymentMethods][applePay]=never&publicOptions[paymentMethods][googlePay]=auto&publicOptions[paymentMethods][paypal]=never&publicOptions[paymentMethods][link]=never&publicOptions[paymentMethods][klarna]=never&publicOptions[paymentMethods][amazonPay]=never&elementsInitSource=checkout&elementId=expressCheckout-bd5f2ba9-c641-4ce8-9c4d-67fc7c6eb45a&componentName=expressCheckout&keyMode=live&apiKey=pk_live_qzXXvTG0TUOVkTZLWsEq7Oqm002yaRpLGH&frameMessagingStrategy=direct&referrer=https%3A%2F%2Fcheckout.stripe.com%2Fc%2Fpay%2Fcs_live_b1bKzkfKNOlemX16UXqoT88VwSasDZvHXu0qiM9Y2lirhKthjQ4ODmLhNX%23fidnandhYHdWcXxpYCc%252FJ2FgY2RwaXEnKSd2cGd2ZndsdXFsamtQa2x0cGBrYHZ2QGtkZ2lgYSc%252FY2RpdmApJ2R1bE5gfCc%252FJ3VuWmlsc2BadH9dXXNRQjVRUEpTblFfSVJ2QHQySnRoNTU3fGRXdUlCTScpJ2N3amhWYHdzYHcnP3F3cGApJ2dkZm5id2pwa2FGamlqdyc%252FJyZjY2NjY2MnKSdpZHxqcHFRfHVgJz8naHBpcWxabHFgaCcpJ2BrZGdpYFVpZGZgbWppYWB3dic%252FcXdwYHgl&controllerId=__privateStripeController4251"
                                  title="Khung Express Checkout an toàn"
                                  style={{
                                    border: "0px !important",
                                    margin: "-4px",
                                    padding: "0px !important",
                                    width: "calc(100% + 8px)",
                                    minWidth: "100% !important",
                                    overflow: "hidden !important",
                                    display: "block !important",
                                    userSelect: "none !important",
                                    transform: "translate(0px) !important",
                                    colorScheme: "light only !important",
                                    height: 0
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* <button
                            className="SubmitButton SubmitButton--incomplete"
                            type="submit"
                            data-testid="hosted-payment-submit-button"
                            style={{
                              backgroundColor: "rgb(0, 116, 212)",
                              color: "rgb(255, 255, 255)"
                            }}
                          >
                            <div
                              className="SubmitButton-Shimmer"
                              style={{
                                background:
                                  "linear-gradient(to right, rgba(0, 116, 212, 0) 0%, rgb(58, 139, 238) 50%, rgba(0, 116, 212, 0) 100%)"
                              }}
                            />
                            <div className="SubmitButton-TextContainer">
                              <span
                                className="SubmitButton-Text SubmitButton-Text--current Text Text-color--default Text-fontWeight--500 Text--truncate"
                                aria-hidden="false"
                              >
                                Đăng ký
                              </span>
                              <span
                                className="SubmitButton-Text SubmitButton-Text--pre Text Text-color--default Text-fontWeight--500 Text--truncate"
                                aria-hidden="true"
                                data-testid="submit-button-processing-label"
                              >
                                Đang xử lý
                              </span>
                            </div>
                            <div className="SubmitButton-IconContainer">
                              <div className="SubmitButton-Icon SubmitButton-SpinnerIcon SubmitButton-Icon--pre">
                                <div className="Icon Icon--md">
                                  <div className="Icon Icon--md Icon--square">
                                    <svg
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                      focusable="false"
                                    >
                                      <ellipse
                                        cx={12}
                                        cy={12}
                                        rx={10}
                                        ry={10}
                                        style={{ stroke: "rgb(255, 255, 255)" }}
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="SubmitButton-CheckmarkIcon">
                              <div className="Icon Icon--md">
                                <div className="Icon Icon--md">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={22}
                                    height={14}
                                    focusable="false"
                                  >
                                    <path
                                      d="M 0.5 6 L 8 13.5 L 21.5 0"
                                      fill="transparent"
                                      strokeWidth={2}
                                      stroke="#ffffff"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </button> */}
                        </div>
                      </div>
                      {/* <div className="flex-item width-12">
                                        <div className="ConfirmPayment-PostSubmit">
                                        <div className="B4eU5jRx__ConfirmTerms">
                                            <div className="AnimateSinglePresence" />
                                            <div className="D_NDnqWc__ConfirmTerms--item Text Text-color--gray600 Text-fontSize--13">
                                            <div>
                                                Bằng cách đăng ký, bạn ủy quyền cho StackBlitz,
                                                Inc. thu phí theo các điều khoản cho đến khi bạn
                                                hủy.
                                            </div>
                                            <div />
                                            </div>
                                            <div className="AnimateSinglePresence" />
                                        </div>
                                        </div>
                                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
      {/* <div className="App-Footer C1hyPwuu__CheckoutFooter">
                        <div />
                        <footer className="JOHDf_Xc__Footer">
                        <div className="GYut03iO__PoweredByStripe">
                            <a
                            className="Link Link--primary"
                            href="https://stripe.com"
                            target="_blank"
                            rel="noopener"
                            >
                            <div className="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                                Được cung cấp bởi{" "}
                                <span>
                                <svg
                                    className="InlineSVG Icon BJN199Au__PoweredByStripe-icon Icon--md"
                                    focusable="false"
                                    width={33}
                                    height={15}
                                    role="img"
                                    aria-labelledby="stripe-title"
                                >
                                    <title id="stripe-title">Stripe</title>
                                    <g fillRule="evenodd">
                                    <path d="M32.956 7.925c0-2.313-1.12-4.138-3.261-4.138-2.15 0-3.451 1.825-3.451 4.12 0 2.719 1.535 4.092 3.74 4.092 1.075 0 1.888-.244 2.502-.587V9.605c-.614.307-1.319.497-2.213.497-.876 0-1.653-.307-1.753-1.373h4.418c0-.118.018-.588.018-.804zm-4.463-.859c0-1.02.624-1.445 1.193-1.445.55 0 1.138.424 1.138 1.445h-2.33zM22.756 3.787c-.885 0-1.454.415-1.77.704l-.118-.56H18.88v10.535l2.259-.48.009-2.556c.325.235.804.57 1.6.57 1.616 0 3.089-1.302 3.089-4.166-.01-2.62-1.5-4.047-3.08-4.047zm-.542 6.225c-.533 0-.85-.19-1.066-.425l-.009-3.352c.235-.262.56-.443 1.075-.443.822 0 1.391.922 1.391 2.105 0 1.211-.56 2.115-1.39 2.115zM18.04 2.766V.932l-2.268.479v1.843zM15.772 3.94h2.268v7.905h-2.268zM13.342 4.609l-.144-.669h-1.952v7.906h2.259V6.488c.533-.696 1.436-.57 1.716-.47V3.94c-.289-.108-1.346-.307-1.879.669zM8.825 1.98l-2.205.47-.009 7.236c0 1.337 1.003 2.322 2.34 2.322.741 0 1.283-.135 1.581-.298V9.876c-.289.117-1.716.533-1.716-.804V5.865h1.716V3.94H8.816l.009-1.96zM2.718 6.235c0-.352.289-.488.767-.488.687 0 1.554.208 2.241.578V4.202a5.958 5.958 0 0 0-2.24-.415c-1.835 0-3.054.957-3.054 2.557 0 2.493 3.433 2.096 3.433 3.17 0 .416-.361.552-.867.552-.75 0-1.708-.307-2.467-.723v2.15c.84.362 1.69.515 2.467.515 1.879 0 3.17-.93 3.17-2.548-.008-2.692-3.45-2.213-3.45-3.225z" />
                                    </g>
                                </svg>
                                </span>
                            </div>
                            </a>
                        </div>
                        <a
                            className="Link _0wMrLFZH__FooterLink Link--primary"
                            href="https://stripe.com/legal/end-users"
                            target="_blank"
                            rel="noopener"
                        >
                            <span className="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                            Điều khoản
                            </span>
                        </a>
                        <a
                            className="Link _0wMrLFZH__FooterLink Link--primary"
                            href="https://stripe.com/privacy"
                            target="_blank"
                            rel="noopener"
                        >
                            <span className="Text Text-color--gray400 Text-fontSize--12 Text-fontWeight--400">
                            Quyền riêng tư
                            </span>
                        </a>
                        </footer>
                    </div> */}
    </div>
  )
}
export default CheckoutPaymentForm;